"use client";
import * as React from "react";
const SvgSentimentVerySatisfiedRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m5.5 6.35.43.43a.6.6 0 0 0 .85 0 .6.6 0 0 0 0-.85l-.7-.7a.8.8 0 0 0-1.14 0l-.7.7a.6.6 0 0 0 0 .85.6.6 0 0 0 .84 0zM8 12.4a4.4 4.4 0 0 0 3.8-2.2.4.4 0 0 0-.35-.6h-6.9a.4.4 0 0 0-.35.6A4.4 4.4 0 0 0 8 12.4m1.22-5.62a.6.6 0 0 0 .85 0l.43-.43.42.43a.6.6 0 0 0 .85 0 .6.6 0 0 0 0-.85l-.7-.7a.8.8 0 0 0-1.13 0l-.7.7a.6.6 0 0 0-.02.85M8 0a8 8 0 0 0-8 8 8 8 0 1 0 16 0 8 8 0 0 0-8-8m0 14.4A6.4 6.4 0 0 1 1.6 8 6.4 6.4 0 1 1 8 14.4" }));
export {
  SvgSentimentVerySatisfiedRound as default
};
